export default "__VITE_ASSET__Blov3ODM__"